export const getNumberWithOrdinal = (index: number) => {
    const suffixes = ["th", "st", "nd", "rd"]
    const v = (index + 1) % 100

    return index + 1 + (suffixes[(v - 20) % 10] || suffixes[v] || suffixes[0])
}
